const {
	VUE_APP_APIPATH,
	VUE_APP_SSOURL,
	VUE_APP_SSR_HOST,
	VUE_APP_LIVEURL,
	VUE_APP_ENVKEY,
	NODE_ENV,
	VUE_APP_WS,
	VUE_APP_CUSTOMURL,
	VUE_APP_V_WEBSITE_HOST,
} = process.env;

// NODE_ENV 只用两个值 , 'development','production'
const domain = `${NODE_ENV == 'development' ? 'https://mlive-b.cdinmu.com' : location.origin}`;

const VUE_APP_HOST = location.origin;
const VUE_APP_LIVE_ENV_HOST = location.origin;

const backstageUrl =
	VUE_APP_ENVKEY === 'v1'
		? 'https://live.inmuu.com/superadmin.html'
		: `https://${VUE_APP_ENVKEY}.tuwenzhibo.com/superadmin.html`;
const env = {
	apiPath: VUE_APP_APIPATH,
	ssoUrl: VUE_APP_SSOURL,
	host: VUE_APP_HOST,
	ssrHost: VUE_APP_SSR_HOST,
	liveUrl: VUE_APP_HOST + '/live',
	authHost: 'https://mc.inmuu.com',
	local: NODE_ENV == 'development',
	key: VUE_APP_ENVKEY,
	cdnHost: 'https://cdn.cdinmu.com',
	cardHost: 'https://card.cdinmu.com',
	uploadHost: 'https://upload.cdinmu.com/' + VUE_APP_ENVKEY,
	cdn: 'https://cdn.ourwill.cn',
	surveyOpenUrl: NODE_ENV == 'development' ? VUE_APP_HOST : location.origin,
	excelHost: VUE_APP_HOST,
	wsPullUrl: VUE_APP_WS,
	domain,
	customBackUrl: VUE_APP_CUSTOMURL,
	liveEnvHost: VUE_APP_LIVE_ENV_HOST,
	emallUrl: location.origin + '/mallmanage/',
	privateMallUrl: location.origin + '/privateMall/',
	questionUrl: location.origin + '/questionnaire/',
	myOrderUrl: location.origin + '/purchase/record',
	backstageUrl,
	vwebsiteUrl: VUE_APP_V_WEBSITE_HOST + '/admin/',
};

export const businessWxInfo = {
	// 服务商CorpID
	corpID: 'ww3470ec7474457ee1',
	redirect_uri: `${env.host}/srv/admin/code`,
};

export default env;
